"use client";
import { jsx as m } from "react/jsx-runtime";
import t from "clsx";
import a from "next/link";
import { memo as c } from "react";
import { Box as i } from "../../blocks/base/Base.js";
import { Text as _ } from "../../typography/Typography.js";
import '../../assets/Breadcrumbs.css';const b = "_breadcrumbs_list_1d2je_1", d = "_breadcrumbs_list__inner_1d2je_15", o = "_breadcrumbs_item_1d2je_19", l = "_active_1d2je_28", r = {
  breadcrumbs_list: b,
  breadcrumbs_list__inner: d,
  breadcrumbs_item: o,
  active: l
}, n = c(
  ({ center: e, children: s }) => /* @__PURE__ */ m("div", { className: r.breadcrumbs_list, children: /* @__PURE__ */ m(
    i,
    {
      gap: 20,
      row: !0,
      center: e,
      className: r.breadcrumbs_list__inner,
      children: s
    }
  ) })
);
n.displayName = "BreadcrumbsBlock";
const u = c(
  ({ text: e, href: s }) => s ? /* @__PURE__ */ m(a, { href: s, className: r.breadcrumbs_item, children: e }) : /* @__PURE__ */ m(
    _,
    {
      text: e,
      className: t(r.breadcrumbs_item, r.active)
    }
  )
);
u.displayName = "BreadcrumbsItem";
export {
  n as BreadcrumbsBlock,
  u as BreadcrumbsItem
};
